import api from './api';
import {User} from '../models/User';
import {AUTH_TOKEN_KEY} from '../constants';

export const validateLoginToken = async (): Promise<User | null> => {
  try {
    const response = await api.get('/halo/auth/validate');
    if (response.data.isValid) {
      return response.data.user;
    }
  } catch (error) {
    console.error('Token validation failed:', error);
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
  return null;
};

export const setLoginToken = (token: string) => {
  console.log("Setting login token: " + token);
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const removeLoginToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};